import { render, staticRenderFns } from "./order.vue?vue&type=template&id=1a00cc28&scoped=true"
import script from "./order.vue?vue&type=script&lang=js"
export * from "./order.vue?vue&type=script&lang=js"
import style0 from "./order.vue?vue&type=style&index=0&id=1a00cc28&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../szc.cycz.cc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a00cc28",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/szc.cycz.cc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a00cc28')) {
      api.createRecord('1a00cc28', component.options)
    } else {
      api.reload('1a00cc28', component.options)
    }
    module.hot.accept("./order.vue?vue&type=template&id=1a00cc28&scoped=true", function () {
      api.rerender('1a00cc28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customerInfo/customerContract/order.vue"
export default component.exports